export default __webpack_public_path__ + "static/media/cr_ps.3ca25849.jpg";